/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Simple_Kits_HintInputs */

const en_simple_kits_hint = /** @type {(inputs: Simple_Kits_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each of these uses WhatsApp as the main path to customers. You can change the details later.`)
};

const id_simple_kits_hint = /** @type {(inputs: Simple_Kits_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semua contoh ini memakai WhatsApp sebagai jalur utama pelanggan. Kamu bisa mengubah isinya nanti.`)
};

/**
* | output |
* | --- |
* | "Each of these uses WhatsApp as the main path to customers. You can change the details later." |
*
* @param {Simple_Kits_HintInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const simple_kits_hint = /** @type {((inputs?: Simple_Kits_HintInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simple_Kits_HintInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_simple_kits_hint(inputs)
	return en_simple_kits_hint(inputs)
});